import { Component, OnInit } from '@angular/core';
import {Store} from "@ngrx/store";
import {AppState} from "../../store/app.state";
import {selectClient} from "../../store/general/general.selectors";
import {ClientUserOutput} from "../../models/client.model";
import {Observable} from "rxjs";
import {AvailableLangs, LangDefinition, TranslocoService} from "@ngneat/transloco";
import {authActions} from "../../store/auth/action-types";

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  availableLanguages: string[];
  selectedLanguage:string ;

  client$ : Observable<ClientUserOutput | undefined>;

  constructor(private _store: Store<AppState>, private _translocoService: TranslocoService) {
    this.client$=_store.select(selectClient)
    this.selectedLanguage = _translocoService.getActiveLang();
    this.availableLanguages = _translocoService.getAvailableLangs() as string[];
  }

  ngOnInit(): void {
  }

  setLanguage($event: any) {
    console.log($event);
    this._translocoService.load($event).subscribe();
    this._translocoService.setActiveLang($event);
  }

  onLogout(): void {
    this._store.dispatch(authActions.loggingOut());
  }
}
